export const formatUtcStringDate = (date: string, language: string) =>
  new Intl.DateTimeFormat(language, {
    dateStyle: 'long',
  }).format(new Date(date));

export const formatUtcStringDateTime = (date: string, language: string) =>
  new Intl.DateTimeFormat(language, {
    dateStyle: 'long',
    timeStyle: 'short',
  }).format(new Date(date));

// Formats a date-only value that is stored as a UTC-midnight datetime. The
// timezone is pinned to UTC so the calendar day never shifts based on the
// viewer's local timezone (which would otherwise cause off-by-one-day display).
export const formatUtcDateOnly = (date: string, language: string) =>
  new Intl.DateTimeFormat(language, {
    dateStyle: 'long',
    timeZone: 'UTC',
  }).format(new Date(date));
